import { HttpErrorResponse } from "@angular/common/http";
import { Component, Input, OnInit } from "@angular/core";
import { DeployService } from "../models/deploy.service";
import { DiffStatsService } from "../models/diff-stats.service";

@Component({
  selector: "ab-diff-stat-blocks",
  templateUrl: "./diff-stat-blocks.component.html",
})
export class DiffStatBlocksComponent implements OnInit {
  @Input() public deploy: any;
  @Input() public displayEmptyState: boolean;
  public diffStats: any;

  constructor(
    private deployService: DeployService,
    private diffStatsService: DiffStatsService,
  ) {}

  public ngOnInit() {
    if (this.deploy.diffStats) {
      return this.setDiffStatBlocksFor(this.deploy.diffStats);
    }

    // There are no available Diff Stats for this deploy so do nothing.
    if (this.deploy.diffStats === null) {
      return;
    }

    this.deployService
      .prev({ projectId: this.deploy.projectId, deployId: this.deploy.id })
      .subscribe(
        (prevDeploy: any) => {
          if (prevDeploy) {
            this.setDiffStatsFor(this.deploy, prevDeploy);
          }
        },
        (error: HttpErrorResponse) => {
          // 404 is expected if there is no previous deploy
          if (error.status === 404) {
            return;
          }
        },
      );
  }

  public trackBy(index: number, _item: any) {
    return index;
  }

  private calculateDiffStatBlocksFor(diffStats: any) {
    const total = diffStats.additions + diffStats.deletions;
    let green = diffStats.additions;
    let red = diffStats.deletions;

    if (total > 5) {
      const i = total / 5;
      green = Math.floor(diffStats.additions / i);
      red = Math.floor(diffStats.deletions / i);
    }

    const grey = 5 - green - red;

    return {
      added: new Array(green),
      deleted: new Array(red),
      neutral: new Array(grey),
    };
  }

  private setDiffStatsFor(deploy: any, prevDeploy: any) {
    if (deploy.revision === prevDeploy.revision) {
      return;
    }

    this.diffStatsService
      .get({
        projectId: this.deploy.projectId,
        prevRevision: prevDeploy.revision,
        revision: deploy.revision,
      })
      .subscribe(
        (diffStats: any) => {
          this.deploy.totalChanges = diffStats.additions + diffStats.deletions;
          this.setDiffStatBlocksFor(diffStats);
        },
        (error: HttpErrorResponse) => {
          // 404 is expected if there are no diff stats for this deploy
          if (error.status === 404) {
            return;
          }
        },
      );
  }

  private setDiffStatBlocksFor(diffStats: any) {
    this.diffStats = diffStats;
    this.diffStats.blocks = this.calculateDiffStatBlocksFor(diffStats);
  }
}
